import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../auth/AuthProvider";
import styles from "./styles/MiniProfileCard.module.css";

interface Stats {
  totalPostagens: number;
  totalCurtidas: number;
}

const MiniProfileCard: React.FC = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    if (!user) return;
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${BASE_URL}/postagens/minhas/stats`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        setStats(res.data);
      } catch (err) {
        console.error("Erro ao buscar estatísticas:", err);
      }
    };
    fetchStats();
  }, [user, BASE_URL]);

  // Função para abrir o modal de login/register
  const openRegisterModal = () => {
    const modalEl = document.getElementById("register-modal");
    if (modalEl) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modalEl);
      bootstrapModal.show();
    }
  };

  // Visitante (não logado)
  if (!user) {
    return (
      <div className={styles.card}>
        <div className={styles.avatarWrapper}>
          <img
            src="/assets/img/users/user-generic.jpg"
            alt="Visitante"
            className={styles.avatar}
          />
        </div>
        <p className={styles.name}>Visitante</p>
        <button
          className={styles.loginButton}
          onClick={openRegisterModal}
        >
          Entrar / Criar conta
        </button>
      </div>
    );
  }

  // Usuário logado
  return (
    <div className={styles.card}>
      <div className={styles.avatarWrapper}>
        <img
          src={
            user.foto
              ? `${BASE_URL}${user.foto.url.replace(/^\/api/, "")}`
              : "/assets/img/users/user-generic.jpg"
          }
          alt={user.nome}
          className={styles.avatar}
        />
      </div>
      <p className={styles.name}>{user.nome}</p>

      <div className={styles.stats}>
        <div>
          <h5>{stats?.totalPostagens ?? 0}</h5>
          <p>Postagens</p>
        </div>
        <div>
          <h5>{stats?.totalCurtidas ?? 0}</h5>
          <p>Curtidas</p>
        </div>
      </div>
    </div>
  );
};

export default MiniProfileCard;